import React from "react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/data";
import { Instagram, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 text-white pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_mobile-detail-pro-26/artifacts/st6pxnfk_2D5BD9E6-85C3-4BF5-B85B-9DAEBA92022E.png"
              alt="DT Detail"
              className="h-20 w-auto mb-5 bg-white p-2 rounded-md inline-block"
            />
            <p className="text-white/60 max-w-md leading-relaxed">
              Mobile auto detailing across Northern Utah. Showroom shine
              delivered to your driveway.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={CONTACT.socials.instagram.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="w-10 h-10 rounded-md bg-white/5 border border-white/10 hover:bg-[#4B0082] hover:border-[#4B0082] flex items-center justify-center transition-all"
              >
                <Instagram className="w-4 h-4 text-white" />
              </a>
              <a
                href={CONTACT.socials.facebook.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Facebook"
                className="w-10 h-10 rounded-md bg-white/5 border border-white/10 hover:bg-[#4B0082] hover:border-[#4B0082] flex items-center justify-center transition-all"
              >
                <Facebook className="w-4 h-4 text-white" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest mb-4">
              Offers
            </h4>
            <ul className="space-y-2 text-white/60">
              <li><a href="#services" className="hover:text-white transition-colors">Exterior</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Interior</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Full Detail</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest mb-4">
              Contact
            </h4>
            <ul className="space-y-2 text-white/60">
              <li>
                <a href={`tel:${CONTACT.phone}`} className="hover:text-white transition-colors">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors break-all">
                  {CONTACT.email}
                </a>
              </li>
              <li>{CONTACT.area}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} DT Detail. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-white/40 hover:text-white text-sm transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
